
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/confirm",
      function () {
        return require("private-next-pages/confirm.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/confirm"])
      });
    }
  